// extracted by mini-css-extract-plugin
export var back = "Hero-module--back--e88eb";
export var background = "Hero-module--background--2e095";
export var breadcrumbContainer = "Hero-module--breadcrumb-container--b4fb4";
export var breadcrumbs = "Hero-module--breadcrumbs--b0f51";
export var button = "Hero-module--button--7c811";
export var content = "Hero-module--content--2ff3c";
export var hasBreadcrumbs = "Hero-module--has-breadcrumbs--2ebb3";
export var hero = "Hero-module--hero--8524f";
export var heroContainer = "Hero-module--heroContainer--e9280";
export var image = "Hero-module--image--3d567";
export var isNews = "Hero-module--is-news--27ba1";
export var main = "Hero-module--main--aabf1";
export var newsBackground = "Hero-module--newsBackground--17ccd";
export var newsContainer = "Hero-module--news-container--4c638";
export var newsTitle = "Hero-module--newsTitle--27a52";
export var smallTitle = "Hero-module--smallTitle--1ed43";
export var testimonialTitle = "Hero-module--testimonialTitle--d3b15";
export var title = "Hero-module--title--38cdf";
export var titleSmall = "Hero-module--titleSmall--0e5fe";
export var wedgeLeft = "Hero-module--wedgeLeft--d5fd1";
export var wedgeRight = "Hero-module--wedgeRight--7bdfe";